// @ts-nocheck
import React from "react";
import { ReactComponent as RewardPointGrowthIcon } from "../../assets/reward-growth-icon-history-large.svg";
import { Spin } from "antd";
import NoPermissionComponent from "modules/kudos-user/component/NoPermissionComponent";
import moment from "moment-timezone";


const RewardSystemHistoryView = (props) => {
  const { historyList, loading, getHistoryData, nextPageCursor, permission } = props;
  return (
    <Spin spinning={loading}>
      {
        permission && historyList.length > 0 ? <div className="history-view">
          <div className="reward-history-container">
            {historyList.map(({ action, date, points }, i) => (
              <div key={i} className="reward-history-row">
                <div className="reward-history-left">
                  <div className="reward-history-circle">
                    <RewardPointGrowthIcon />
                  </div>
                  <div className="reward-history-details">
                    <div className="reward-history-title">{action}</div>
                    <div className="reward-history-date">{date && moment(date).format('MMM DD, YYYY')}</div>
                  </div>
                </div>
                <div className="reward-history-right">
                  <div className="reward-history-points">{`+${points}`}</div>
                  <div className="reward-history-points-label">points</div>
                </div>
              </div>
            ))}
          </div>
          {nextPageCursor && !loading && (
            <div className="load-more-container">
              <button className="load-more-button" onClick={() => { getHistoryData(nextPageCursor) }}>Load More</button>
            </div>
          )}
        </div>
          : !loading && permission && <div className="no-activities-container">
            No Data Found
          </div>
      }
      {
        !loading && !permission && (
          <NoPermissionComponent />
        )
      }
    </Spin>
  );
}

export default RewardSystemHistoryView;